import {apiFetch as fetch} from './sessionInstance';
// Web / Telegram: server AI tasks, assistant connections and their inbox (cloudflare/src/ai.ts), with the session cookie.
import type { AiStatus, AiToken, AiInboxItem } from '../types';
import { ApiError } from './auth';

export const aiAvailable = true;

async function call<T>(method: string, path: string, body?: unknown, base = '/api/ai'): Promise<T> {
  const res = await fetch(`${base}${path}`, {
    method, credentials: 'same-origin',
    headers: body === undefined ? undefined : { 'content-type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as { error?: string; retryAfter?: number } & T;
  if (!res.ok) throw new ApiError(data.error ?? `http_${res.status}`, data.retryAfter);
  return data;
}
const id = encodeURIComponent;

export const status = () => call<AiStatus>('GET', '');
export const tokens = async () => (await call<{ tokens: AiToken[] }>('GET', '/tokens')).tokens;
export const createToken = (label: string, scope: AiToken['scope']) => call<AiToken & { token: string; url: string }>('POST', '/tokens', { label, scope });
export const revokeToken = async (tokenId: string) => (await call<{ tokens: AiToken[] }>('DELETE', `/tokens/${id(tokenId)}`)).tokens;
export const inbox = async () => (await call<{ items: AiInboxItem[] }>('GET', '/inbox')).items;
export const removeInboxItem = async (itemId: string): Promise<void> => {
  await call('DELETE', `/inbox/${id(itemId)}`);
};

/** OAuth consent (cloudflare/src/oauth.ts): who is asking, and the person's answer. */
export type OAuthParams = Record<string, string>;
export const oauthClient = (params: OAuthParams) =>
  call<{ name: string; known: string | null; host: string; scopes: ('read' | 'propose' | 'full')[] }>('GET', `/client?${new URLSearchParams(params)}`, undefined, '/api/oauth');
export const oauthAnswer = (params: OAuthParams, allow: boolean, grant: 'read' | 'propose' | 'full') =>
  call<{ redirect: string }>('POST', '/approve', { ...params, allow, grant }, '/api/oauth');
/** Hands the browser back to the assistant (same tab, as OAuth expects). */
export function leaveTo(url: string): void {
  window.location.assign(url);
}
